<style lang="scss">
@import '../assets/sass/abstracts/_variables.scss';

div.filters-container {
  background-color: white;
  position: fixed;
  left: 0;
  bottom: 0;
  top: 74px;
  max-width: 550px;
  width: 35%;
  padding-top: 22px;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16),
    0 0 0 1px rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  z-index: 401;
  
  div.close-filters {
    height: 90px;
    width: 23px;
    position: absolute;
    right: -23px;
    background-color: white;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    line-height: 90px;
    top: 50%;
    cursor: pointer;
    margin-top: -82px;
    text-align: center;
    border-bottom: 1px solid $nina-gray;
    border-top: 1px solid $nina-gray;
    border-right: 1px solid $nina-gray;
  }
  span.filters-header {
    display: block;
    font-family: 'Lato', sans-serif;
    font-weight: bold;
    margin-bottom: 10px;
  }
  div.filters-text {
    display: block;
    font-family: 'Lato', sans-serif;
    margin-bottom: 15px;
  }
  label.filter-label {
    font-family: 'Lato', sans-serif;
    text-transform: uppercase;
    font-weight: bold;
    color: black;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .italic {
    font-style: italic;
  }

  .links-container {
    margin-top: 20px;
    a {
      color: $nina-darkgray;
      display: block;
      margin: 10px 0;
      text-decoration: none;
      font-weight: bold;
      font-size: 14px;
      &:hover {
        color: $nina-signalorange;
      }
    }
  }
  .close {
    float: right;
    padding-right: 8px;
    margin-bottom: 5px;
    display: none;
  }
}

.leaflet-bottom.leaflet-right {
  z-index: 400;
}

/* Small only */
@media screen and (max-width: 39.9375em), screen and (max-height: 800px) {
  div.filters-container div.close-filters {
    display: none;
  }
  div.filters-container {
    top: 75px;
    padding-top: 10px;
    width: 100%;
    overflow-y: auto;
    .close {
      display: block;
    }
  }
}
</style>

<template>
  <transition name="slide-in-left">
    <div class="filters-container" v-show="showFilters">
      <div class="close-filters" v-on:click="toggleShowFilters()">
        <img :src="require('@/assets/img/grey-left.svg')">
      </div>
      <div class="close" v-on:click="toggleShowFilters()">
        <img class="close-icon" src="../assets/img/close-icon.svg">
      </div>
      <div style="clear:both"></div>
      <div class="content-container">
      <div class="grid-x grid-padding-x">
        <div class="large-12 medium-12 small-12 cell">
          <div class="filters-text">
            <h2 class="h2-custom">Om portalen</h2>
            <p>NINA og Havforskningsinstituttet klassifiserer i fellesskap ville laksebestander med hensyn til genetisk innkryssing av rømt oppdrettslaks i villaks. Oppdraget fra Klima- og miljødepartementet er å gi en felles vurdering av kvalitetselementet «Genetisk integritet» til klassifisering av villaksbestander etter «Kvalitetsnorm for ville bestander av laks (<em>Salmo salar</em>)». Nettportalen presenterer oppdatert status med mulighet til å søke opp enkeltbestander med data for klassifiseringen. Det er mulig å søke på vassdragsnavn, vassdragsnummer eller å bla i listen over vassdrag fra hvert fylke. Vassdrag kan ofte ha flere forskjellige navn og et alternativ kan derfor være å søke i kartet. Utviklingen av nettportalen er finansiert av Miljødirektoratet.</p>  
          </div>
        </div>
      </div>

      <div class="grid-x grid-padding-x">
        <div class="large-12 medium-12 small-12 cell">
          <h2 class="h2-custom">Søk etter vassdrag</h2>
        </div>
      </div>

      <div class="grid-x grid-padding-x">
        <div class="large-12 medium-12 small-12 cell">
          <v-select
            v-model="selectedWatercourse"
            :options="watercourses"
            placeholder="Søk etter navn, nummer eller fylke"
            label="fullname"
          >
            <template slot="selected-option" slot-scope="option">
              <div>
                <span>{{ option.name }}</span>
                <span
                  style="text-transform: uppercase; font-size: 12px; margin-left: 10px;"
                >({{ option.watercourseNumber }} - {{ option.county }})</span>
              </div>
            </template>
            <template slot="option" slot-scope="option">
              <div>{{ option.name }}</div>
              <div style="text-transform: uppercase; font-size: 12px">
                Vnr:
                <strong>{{ option.watercourseNumber }}</strong>
                Fylke:
                <strong>{{option.county}}</strong>
              </div>
            </template>
          </v-select>
        </div>
      </div>
      <div class="links-container">

        <div class="grid-x grid-padding-x">
          <div class="large-12 medium-12 small-12 cell">
            <h2 class="h2-custom"><router-link :to="{ name: 'methodAndClassification' }">Metode og klassifisering</router-link></h2>
          </div>
        </div>
 
        <div class="grid-x grid-padding-x">
          <div class="large-12 medium-12 small-12 cell">
            <h2 class="h2-custom"><router-link :to="{ name: 'status' }">Oppdatert status 2023</router-link></h2>
            
          </div>
        </div>

        <div class="grid-x grid-padding-x">
          <div class="large-12 medium-12 small-12 cell">
            <h2 class="h2-custom"><router-link :to="{ name: 'literature' }">Litteratur</router-link></h2>
            
          </div>
        </div>
      </div>
    </div>
    </div>
  </transition>
</template>

<script>
import { EventBus } from '../event-bus.js';
import router from '../router.js';
import Vue from 'vue';
import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

export default {
  data() {
    return {
      selectedWatercourse: null,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    EventBus.$on(
      'show-filters',
      function() {
        this.showFilters = true;
      }.bind(this)
    );

    EventBus.$on(
      'hide-filters',
      function() {
        this.showFilters = false;
      }.bind(this)
    );
  },
  methods: {
    toggleShowFilters() {
      this.$store.dispatch('toggleShowFilters', {
        showFilters: !this.showFilters
      });
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (window.innerWidth < 480) {
        this.$store.dispatch('toggleShowFilters', {
          showFilters: false
        });
        this.$store.dispatch('toggleLegendDisplay', {
          showFilters: false
        });
      }
    }
  },
  computed: {
    showFilters() {
      return this.$store.getters.getShowFilters;
    },
    watercourses() {
      return this.$store.getters.getWatercourses;
    }
  },
  watch: {
    selectedWatercourse: function(newWatercourse) {
      if (newWatercourse !== null) {
        this.$store.dispatch('loadWatercourse', { id: newWatercourse.id });
        router.push({ name: 'watercourse', params: { id: newWatercourse.id } });
        EventBus.$emit('location-selected', {
          lat: parseFloat(newWatercourse.latitude),
          lng: parseFloat(newWatercourse.longitude)
        });
      }
    }
  }
};
</script>
